import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  iframeUrl: "嵌套链接地址",
  iframeScrollStatus: "是否60px"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
